// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customTabs .ant-tabs-nav {
  border-bottom: 1px solid #dedede !important;
}
.customTabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #0a7f8f !important;
  border-bottom: 2px solid #24929c !important;
}
.customTabs .ant-tabs-tab-btn {
  padding-bottom: 6px !important;
}
.customTabs .ant-tabs-tab:hover .ant-tabs-tab-btn {
  color: #24929c !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/CommonCommponents/Tabs/Tabs.scss"],"names":[],"mappings":"AAEE;EACE,2CAAA;AADJ;AAKE;EACE,yBAAA;EACA,2CAAA;AAHJ;AAOE;EACE,8BAAA;AALJ;AASE;EACE,yBAAA;AAPJ","sourcesContent":[".customTabs {\n  // Base line under all tabs\n  .ant-tabs-nav {\n    border-bottom: 1px solid #dedede !important;\n  }\n\n  // Active tab underline (this is the correct AntD selector)\n  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n    color: #0a7f8f !important;\n    border-bottom: 2px solid #24929c !important;\n  }\n\n  // Optional: add padding to make underline visible below text\n  .ant-tabs-tab-btn {\n    padding-bottom: 6px !important;\n  }\n\n  // Hover color\n  .ant-tabs-tab:hover .ant-tabs-tab-btn {\n    color: #24929c !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
